import React, { ChangeEvent, useEffect, useState } from 'react';
import { useAppStateAPI } from '../common/AppStateAPI';
import * as ServerAPI from '../common/ServerAPI';
import { APIData } from '../common/DataTypes';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useParams } from 'react-router-dom';
import Footer from '../components/Footer';
import Description from '../common/Description';
import Preloader from '../components/Preloader';
import Header from '../components/Header';

const SingleBlog: React.FC = () => {
    const [message, setMessage] = useState<string>('');
    const { showToastMsg, addProcessingRequests, reduceProcessingRequests } = useAppStateAPI();
    const [vehicleDetail, setVehicleDetail] = useState<APIData.VehicleDetail>();
    const { vehicle_id } = useParams<{ vehicle_id: string }>();
    const cleanDescription = vehicleDetail?.vehicle_description || '';

    useEffect(() => {
        console.log("Vehicle ID from URL:", vehicle_id); // Log vehicle_id
        if (vehicle_id) {
            fetchVehicleDetail(Number(vehicle_id));
        }
    }, [vehicle_id]);

    const fetchVehicleDetail = (vehicleID: number) => {
        addProcessingRequests();
        ServerAPI.getVehicleDetail(vehicleID)
            .then((response) => {
                console.log('API Response for vehicle detail:', response); // Log the response
                if (response.success && response.vehicles.length > 0) {
                    const vehicleData = response.vehicles[0];
                    setVehicleDetail(vehicleData);
                } else {
                    showToastMsg("error", response.message || "No vehicle details found.");
                }
            })
            .catch((error) => {
                showToastMsg("error", "Error occurred while fetching vehicle details.");
            })
            .finally(() => {
                reduceProcessingRequests();
            });
    };


    const galleryImages = vehicleDetail?.vehicle_images?.map((image) => ({
        original: image.vehicle_image,
        thumbnail: image.vehicle_image,
    })) || [];


    useEffect(() => {
        // Popup handling
        const openPopupButton = document.getElementById('open-popup') as HTMLButtonElement | null;
        const popup = document.getElementById('test-drive') as HTMLElement | null;
        const closePopupButton = popup?.querySelector('.close-popup') as HTMLButtonElement | null;

        if (openPopupButton && popup && closePopupButton) {
            openPopupButton.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault(); // Prevent default anchor behavior
                popup.style.display = 'flex'; // Show the popup
            });

            closePopupButton.addEventListener('click', () => {
                popup.style.display = 'none'; // Hide the popup
            });

            // Close popup when clicking outside the popup content
            const handleWindowClick = (event: MouseEvent) => {
                if (event.target === popup) {
                    popup.style.display = 'none'; // Hide the popup
                }
            };

            window.addEventListener('click', handleWindowClick);

            // Clean up the event listeners when the component is unmounted
            return () => {
                window.removeEventListener('click', handleWindowClick);
            };
        }
    }, []); // Empty dependency array ensures this runs once when the component mounts

    useEffect(() => {
        // Phone number input with intlTelInput handling
        const phoneInputField = document.querySelector("#test_driver_phone") as HTMLInputElement | null;

        const initIntlTelInput = () => {
            if (phoneInputField && (window as any).intlTelInput) {
                const iti = (window as any).intlTelInput(phoneInputField, {
                    initialCountry: "auto", // Automatically detects the user's country
                    geoIpLookup: (callback: (countryCode: string) => void) => {
                        fetch('https://ipinfo.io/json', { headers: { 'Accept': 'application/json' } })
                            .then((resp) => resp.json())
                            .then((resp) => {
                                const countryCode = resp?.country || "us";
                                callback(countryCode);
                            })
                            .catch(() => callback("us"));
                    },
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js" // Loads utils.js to handle validation
                });

                // Optional: Validation on form submission
                const form = document.querySelector('form');
                if (form) {
                    form.addEventListener('submit', (e: Event) => {
                        if (!(iti as any).isValidNumber()) {
                            e.preventDefault();
                            alert("Please enter a valid phone number.");
                        }
                    });
                }
            }
        };

        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js';
        script.async = true;
        script.onload = initIntlTelInput;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        // Slideshow handling
        let index = 0;
        const slides = document.querySelectorAll('.slide') as NodeListOf<HTMLElement>;
        const nextButton = document.querySelector('.next-button') as HTMLButtonElement | null;

        if (nextButton && slides.length > 0) {
            const handleNextSlide = () => {
                slides[index].classList.remove('active');
                index = (index + 1) % slides.length;
                slides[index].classList.add('active');
                slides[(index + 1) % slides.length].classList.add('next');
            };

            nextButton.addEventListener('click', handleNextSlide);

            const interval = setInterval(() => {
                slides[index].classList.remove('active');
                index = (index + 1) % slides.length;
                slides[index].classList.add('active');
            }, 10000); // 10-second interval

            // Clean up interval and event listener on unmount
            return () => {
                clearInterval(interval);
                nextButton.removeEventListener('click', handleNextSlide);
            };
        }
    }, []);

    const handleMessageChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        setMessage(event.target.value);
    };
    return (
        <>
            <Preloader />
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
            {/* Start Header Section */}
            <Header />
            <div className="container">
                <div className="d-md-flex justify-content-between align-items-center">
                    <div className="common-page-title">
                        <h3 className="page-title">Car Details</h3>
                        <div className="d-flex gap-2 align-items-center">
                        </div>
                    </div>
                </div>
                <div className="primary-color-border"></div>
            </div>
            {/* End common page title */}


            {/* Start blog content */}
            <div className="ak-height-40 ak-height-lg-40"></div>
            <div className="container container-customize">
                <div>
                    <div className="time-title" data-aos-delay="600">
                        <h3 className="page-title">
                            {vehicleDetail?.vehicle_title}
                        </h3>
                        <h4 className="title">  <ImageGallery items={galleryImages} />
                        </h4>
                        <div className="ak-height-50 ak-height-lg-30"></div>
                    </div>
                    <section id="item-details">
                        <div className="table-container">
                            <div className="table-column">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Make:</th>
                                            <td> {vehicleDetail?.vehicle_brand_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Model:</th>
                                            <td> {vehicleDetail?.vehicle_model_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Year:</th>
                                            <td> {vehicleDetail?.vehicle_manufacture_year}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Wheels:</th>
                                            <td> {vehicleDetail?.vehicle_wheel_size}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Color:</th>
                                            <td> {vehicleDetail?.exterior_color_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Vehicle type:</th>
                                            <td> {vehicleDetail?.vehicle_body_type_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Kilometers:</th>
                                            <td> {vehicleDetail?.vehicle_km_run}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Export status:</th>
                                            <td> <p>
                                                {vehicleDetail?.vehicle_export_availability === 1 ? "Yes" : "No"}
                                            </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="table-column">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th scope="row">Specs:</th>
                                            <td> {vehicleDetail?.vehicle_spec_name}</td>
                                        </tr>
                                        <tr>
                                            {/* <th scope="row">Gearbox:</th>
                                            <td> {GetVehicle.length > 0 && GetVehicle[0].vehicle_ge}</td> */}
                                        </tr>
                                        <tr>
                                            <th scope="row">Fuel:</th>
                                            <td> {vehicleDetail?.fuel_type_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Seats:</th>
                                            <td> {vehicleDetail?.vehicle_seating_capacity}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Cylinders:</th>
                                            <td> {vehicleDetail?.vehicle_engine_cylinders}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Interior:</th>
                                            <td> {vehicleDetail?.interior_color_name}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Price:</th>
                                            <td>
                                                <strong className="money total-price normal-price">USD {vehicleDetail?.vehicle_price}</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <section id="dealer-info">
                                <div id="contact-buttons">
                                    {/* Call Us Button with Phone Icon */}
                                    <a href="tel:+971585504939" id="dealer-contact-call-btn"
                                        data-gtm="{&quot;label&quot;: &quot;Call dealer 754964&quot;, &quot;event&quot;: &quot;showNumber&quot;}"
                                        data-sp-lead="{&quot;e&quot;:&quot;lead&quot;,&quot;lt&quot;:&quot;phone&quot;,&quot;ls&quot;:&quot;call-dealer&quot;}"
                                        className="button block large"
                                        data-track="{&quot;ev&quot;: &quot;ItemLead&quot;, &quot;spData&quot;: &quot;sp-lead&quot;}"
                                        data-no-instant=""
                                        style={{ backgroundColor: '#F4C430', color: 'white' }}>
                                        <i className="fa-solid fa-phone"></i> Call us
                                    </a>

                                    {/* Email Us Button with Email Icon */}
                                    <a href="mailto:Harsha@kayrahcars.com" id="dealer-info-dealer-contact"
                                        data-gtm="{&quot;action&quot;: &quot;DescriptionEmail&quot;, &quot;label&quot;: &quot;Email button click on description 754964&quot;, &quot;event&quot;: &quot;addEvent&quot;}"
                                        data-sp-ajax-form="{&quot;e&quot;:&quot;lead&quot;,&quot;lt&quot;:&quot;email&quot;,&quot;ls&quot;:&quot;contact-dealer&quot;}"
                                        className="button block large"
                                        style={{ backgroundColor: '#EA4335', color: 'white' }}>
                                        <i className="fa-solid fa-envelope"></i> Email us
                                    </a>


                                    {/* WhatsApp Button with WhatsApp Icon */}
                                    <a id="whatsapp-link"
                                        href="https://api.whatsapp.com/send?phone=971585504939&text=Hi%2C+I+saw+your+car+ad+on+kayrahs.+Is+it+still+available%3F"
                                        data-track="{&quot;ev&quot;: &quot;ItemLead&quot;, &quot;spData&quot;: &quot;sp-lead&quot;}"
                                        data-sp-lead="{&quot;e&quot;:&quot;lead&quot;,&quot;lt&quot;:&quot;social&quot;,&quot;ls&quot;:&quot;whatsapp&quot;}"
                                        data-gtm="{&quot;action&quot;: &quot;WhatsApp&quot;, &quot;category&quot;: &quot;Lead&quot;, &quot;label&quot;: &quot;Click WhatsApp button on item page 754964&quot;, &quot;event&quot;: &quot;addEvent&quot;}"
                                        className="whatsapp-link button large whatsapp block"
                                        target="_blank"
                                        style={{ backgroundColor: '#25D366', color: 'white' }}>
                                        <i className="fa-brands fa-whatsapp"></i> WhatsApp
                                    </a>
                                </div>
                            </section>

                        </div>

                        <section id="item-description"> <b
                            style={{
                                textTransform: 'uppercase',
                                marginBottom: '10px',
                                display: 'block'
                            }}>Description</b>

                            <Description
                                htmlContent={cleanDescription}
                                maxLength={300}
                            />

                        </section>
                        <section id="item-features">
                            <div className="feature-section">
                                {/* Left Column (Interior) */}
                                {vehicleDetail && vehicleDetail.vehicle_features &&
                                    vehicleDetail.vehicle_features.some(featureCategory => featureCategory.feature_category_name === "Interior" && featureCategory.feature_values.length > 0) && (
                                        <div className="feature-column">
                                            <span className="feature-heading">Interior</span>
                                            <ul className="check">
                                                {vehicleDetail.vehicle_features.map((featureCategory) => (
                                                    featureCategory.feature_category_name === "Interior" ? (
                                                        featureCategory.feature_values.map((featureValue) => (
                                                            <li key={featureValue.feature_value_id}>
                                                                {featureValue.feature_value_text}
                                                            </li>
                                                        ))
                                                    ) : null
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                {/* Right Column (Exterior) */}
                                {vehicleDetail && vehicleDetail.vehicle_features &&
                                    vehicleDetail.vehicle_features.some(featureCategory => featureCategory.feature_category_name === "Exterior" && featureCategory.feature_values.length > 0) && (
                                        <div className="feature-column">
                                            <span className="feature-heading">Exterior</span>
                                            <ul className="check">
                                                {vehicleDetail.vehicle_features.map((featureCategory) => (
                                                    featureCategory.feature_category_name === "Exterior" ? (
                                                        featureCategory.feature_values.map((featureValue) => (
                                                            <li key={featureValue.feature_value_id}>
                                                                {featureValue.feature_value_text}
                                                            </li>
                                                        ))
                                                    ) : null
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                            </div>

                            {/* Safety Section */}
                            <div className="feature-section">
                                {vehicleDetail && vehicleDetail.vehicle_features &&
                                    vehicleDetail.vehicle_features.some(featureCategory => featureCategory.feature_category_name === "Safety" && featureCategory.feature_values.length > 0) && (
                                        <div className="feature-column">
                                            <span className="feature-heading">Safety</span>
                                            <ul className="check">
                                                {vehicleDetail.vehicle_features.map((featureCategory) => (
                                                    featureCategory.feature_category_name === "Safety" ? (
                                                        featureCategory.feature_values.map((featureValue) => (
                                                            <li key={featureValue.feature_value_id}>
                                                                {featureValue.feature_value_text}
                                                            </li>
                                                        ))
                                                    ) : null
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                            </div>
                        </section>
                        <section id="item-book_test_drive">
                            {/* Book Test Drive Button */}
                            <div className="feature-section">
                                <div>
                                    <section id="book-testdrive">
                                        <button className="common-btn">
                                            <a className="button block large testdrive-button"
                                                href="#test-drive"
                                                id="open-popup"
                                                data-sp-ajax-form="{&quot;e&quot;:&quot;lead&quot;,&quot;lt&quot;:&quot;email&quot;,&quot;ls&quot;:&quot;test-drive&quot;}">
                                                Book a test drive
                                            </a>
                                        </button>
                                    </section>
                                </div>
                            </div>
                        </section>
                    </section>
                </div>
                <section id="test-drive" className="lead-popup popup">
                    <div className="popup-content">
                        <h2 className="small" style={{ color: 'black' }}>Book a test drive</h2>
                        <div className="item-info">
                            <div className="aspect">
                                {vehicleDetail?.vehicle_default_image ? (
                                    <img
                                        src={vehicleDetail.vehicle_default_image}
                                        alt={vehicleDetail?.vehicle_title} // Use vehicle title for alt text
                                        style={{ width: '200px', height: 'auto', objectFit: 'cover', minHeight: '150px' }} // Set your desired styles
                                    />
                                ) : (
                                    <p>No default image available</p> // Optional: handle case where there is no default image
                                )}
                                <p className="price">USD {vehicleDetail?.vehicle_price}</p>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="first_name">Name</label>
                                    <input id="first_name" data-preserve="true" name="first_name"
                                        type="text" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="test_driver_email">Email</label>
                                    <input id="test_driver_email" data-preserve="true" name="email"
                                        type="email" required />
                                </div>
                            </div><br />
                            <div className="form-group">
                                <label htmlFor="test_driver_phone">Mobile Number</label>
                                <input id="test_driver_phone" className="international-phone-number" name="phone" type="tel"
                                    placeholder="+91 9999999999" required />
                            </div>
                            <br />
                            <div className="form-group">
                                <label>message</label>
                                <textarea
                                    rows={3}
                                    cols={40}
                                    id="test_driver_message"
                                    name="message"
                                    //  value={onmessage}
                                    onChange={handleMessageChange}
                                />
                            </div>
                            <div className="form-group">
                                <button className="close-popup">Close</button>&nbsp;
                                <button className="send-popup">Send</button>
                            </div>
                        </div>
                    </div>
                </section>

                <div>
                    <div className="primary-color-border"></div>

                    <div className="mt-3">
                        <div className="d-flex align-items-center">
                            <p className="me-5">Social Share:</p>
                            <div className="social-icon">
                                <a href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                        fill="none">
                                        <g clip-path="url(#clip0_365_2387)">
                                            <path
                                                d="M15.995 16.9761L15.999 16.9754L15.999 11.1074C15.999 8.23672 15.381 6.02539 12.025 6.02539C10.4117 6.02539 9.32899 6.91072 8.88699 7.75006H8.84033V6.29339L5.65833 6.29339L5.65833 16.9754H8.97166L8.97166 11.6861C8.97166 10.2934 9.23566 8.94672 10.9603 8.94672C12.6597 8.94672 12.685 10.5361 12.685 11.7754L12.685 16.9761H15.995Z"
                                                fill="white" />
                                            <path
                                                d="M0.263062 6.29395L3.5804 6.29395L3.5804 16.9759H0.263062L0.263062 6.29395Z"
                                                fill="white" />
                                            <path
                                                d="M1.92036 0.975586C0.85969 0.975586 -0.000976563 1.83625 -0.000976563 2.89692C-0.000976563 3.95759 0.85969 4.83625 1.92036 4.83625C2.98102 4.83625 3.84169 3.95759 3.84169 2.89692C3.84102 1.83625 2.98036 0.975586 1.92036 0.975586Z"
                                                fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_365_2387">
                                                <rect width="16" height="16" fill="white"
                                                    transform="translate(-0.000976562 0.975586)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                        fill="none">
                                        <g clip-path="url(#clip0_365_2385)">
                                            <path
                                                d="M9.2381 16.9756L9.2381 9.67777L11.6867 9.67777L12.0541 6.83284H9.2381V5.01676C9.2381 4.19335 9.46582 3.6322 10.6479 3.6322L12.1532 3.63158V1.08697C11.8929 1.05314 10.9993 0.975586 9.95931 0.975586C7.78764 0.975586 6.30087 2.30116 6.30087 4.735L6.30087 6.83284H3.84485L3.84485 9.67777H6.30087L6.30087 16.9756H9.2381Z"
                                                fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_365_2385">
                                                <rect width="16" height="16" fill="white"
                                                    transform="translate(-0.000976562 0.975586)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                        fill="none">
                                        <g clip-path="url(#clip0_365_2391)">
                                            <path
                                                d="M15.9833 4.94233C15.9459 4.09218 15.8084 3.50772 15.6114 3.00127C15.4083 2.46369 15.0957 1.9824 14.6862 1.58229C14.2861 1.17596 13.8016 0.860229 13.2703 0.660239C12.7609 0.463301 12.1795 0.325823 11.3294 0.28834C10.4729 0.247682 10.201 0.238281 8.02866 0.238281C5.85636 0.238281 5.58446 0.247682 4.73114 0.285165C3.881 0.322648 3.29654 0.460248 2.79021 0.657064C2.25251 0.860229 1.77121 1.17279 1.37111 1.58229C0.964783 1.9824 0.649169 2.46687 0.449057 2.99822C0.252119 3.50772 0.114641 4.08901 0.0771582 4.93915C0.0365009 5.79564 0.0270996 6.06754 0.0270996 8.23984C0.0270996 10.4121 0.0365009 10.684 0.0739838 11.5374C0.111467 12.3875 0.249067 12.972 0.446005 13.4784C0.649169 14.016 0.964783 14.4973 1.37111 14.8974C1.77121 15.3037 2.25568 15.6195 2.78704 15.8195C3.29654 16.0164 3.87783 16.1539 4.72809 16.1913C5.58129 16.229 5.85331 16.2382 8.02561 16.2382C10.1979 16.2382 10.4698 16.229 11.3231 16.1913C12.1733 16.1539 12.7577 16.0164 13.2641 15.8195C14.3393 15.4037 15.1895 14.5536 15.6052 13.4784C15.802 12.9689 15.9396 12.3875 15.9771 11.5374C16.0146 10.684 16.024 10.4121 16.024 8.23984C16.024 6.06754 16.0208 5.79564 15.9833 4.94233ZM14.5425 11.4749C14.5081 12.2563 14.3768 12.6782 14.2674 12.9595C13.9986 13.6566 13.4454 14.2098 12.7483 14.4786C12.467 14.588 12.042 14.7193 11.2637 14.7536C10.4198 14.7912 10.1667 14.8005 8.03184 14.8005C5.89702 14.8005 5.64075 14.7912 4.79988 14.7536C4.01848 14.7193 3.59652 14.588 3.31522 14.4786C2.96835 14.3504 2.65261 14.1472 2.39634 13.8816C2.13066 13.6221 1.9275 13.3096 1.7993 12.9627C1.6899 12.6814 1.55865 12.2563 1.52434 11.478C1.48674 10.6341 1.47746 10.3809 1.47746 8.24607C1.47746 6.11125 1.48674 5.85498 1.52434 5.01424C1.55865 4.23284 1.6899 3.81088 1.7993 3.52957C1.9275 3.18258 2.13066 2.86697 2.39951 2.61057C2.65884 2.34489 2.9714 2.14173 3.31839 2.01365C3.5997 1.90426 4.02483 1.773 4.80306 1.73857C5.64697 1.70109 5.9002 1.69169 8.03489 1.69169C10.1729 1.69169 10.426 1.70109 11.2668 1.73857C12.0482 1.773 12.4702 1.90426 12.7515 2.01365C13.0984 2.14173 13.4141 2.34489 13.6704 2.61057C13.9361 2.87002 14.1392 3.18258 14.2674 3.52957C14.3768 3.81088 14.5081 4.23589 14.5425 5.01424C14.58 5.85815 14.5894 6.11125 14.5894 8.24607C14.5894 10.3809 14.58 10.6309 14.5425 11.4749Z"
                                                fill="white" />
                                            <path
                                                d="M8.02864 4.12988C5.75951 4.12988 3.91846 5.97082 3.91846 8.24006C3.91846 10.5093 5.75951 12.3502 8.02864 12.3502C10.2979 12.3502 12.1388 10.5093 12.1388 8.24006C12.1388 5.97082 10.2979 4.12988 8.02864 4.12988ZM8.02864 10.9062C6.55655 10.9062 5.36246 9.71227 5.36246 8.24006C5.36246 6.76785 6.55655 5.57389 8.02864 5.57389C9.50085 5.57389 10.6948 6.76785 10.6948 8.24006C10.6948 9.71227 9.50085 10.9062 8.02864 10.9062Z"
                                                fill="white" />
                                            <path
                                                d="M13.261 3.96735C13.261 4.49724 12.8313 4.92689 12.3013 4.92689C11.7714 4.92689 11.3418 4.49724 11.3418 3.96735C11.3418 3.43734 11.7714 3.00781 12.3013 3.00781C12.8313 3.00781 13.261 3.43734 13.261 3.96735Z"
                                                fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_365_2391">
                                                <rect width="16" height="16" fill="white"
                                                    transform="translate(-0.000976562 0.238281)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a href="#">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17"
                                        fill="none">
                                        <path
                                            d="M9.2757 7.92516L14.2721 2.11719H13.0882L8.74973 7.16017L5.28465 2.11719H1.28809L6.52797 9.74307L1.28809 15.8336H2.47215L7.05364 10.5081L10.713 15.8336H14.7096L9.27541 7.92516H9.2757ZM7.65396 9.81025L7.12305 9.05089L2.89879 3.00853H4.71745L8.12647 7.88491L8.65738 8.64427L13.0887 14.9828H11.2701L7.65396 9.81054V9.81025Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* End Social Share */}

            </div>
            {/* End blog content */}

            <Footer />
            {/* Start Footer */}

            {/* End Footer */}
            <span className="ak-scrollup">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
                        fill="currentColor" />
                </svg>
            </span>
        </>

    );
};

export default SingleBlog;

